<div
  [class.loadingUrl]="loadingUrl"
  (click)="helpPopup()"
>
  @if (loadingUrl) {
    <div
      class="icon"
    >
      <motn-spinner></motn-spinner>
    </div>
  }

  @if (!loadingUrl) {
    <div
      class="icon"
    >
      <span class="fa-layers">
        <i
          class="fa-solid fa-seal"
        ></i>
        <i
          class="fa-solid fa-seal-question"
        ></i>
      </span>
    </div>
  }

  <div class="text">
    Help Center
  </div>
</div>
